const trimTrailingSlash = (value: string | undefined) => (value ?? '').replace(/\/$/, '')

/** API application base path. Requests remain relative to the current IIS host. */
export const env = Object.freeze({
  apiBaseUrl: trimTrailingSlash(import.meta.env.VITE_API_URL || '/webapi'),
  mode: import.meta.env.MODE,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
})

export type AppEnv = typeof env
